/*
 * gift-option.js — [Platypus 2026-08-26]
 *
 * Drives the "Make it a gift" checkbox added in sections/main-cart-footer.liquid.
 *
 * WHY THIS IS A THEME ASSET AND NOT AN INLINE <script> IN THE SECTION:
 * this theme navigates by fetching the next page and writing it into #MainContent with
 * innerHTML (see updatePage() in global.js). A <script> inserted through innerHTML never
 * executes — that is a DOM rule, not a bug — and global.js deliberately strips script tags
 * out of the injected HTML anyway, to avoid duplicate declarations. So an inline script in a
 * section runs on a hard page load and never again. It "works" when you refresh and is dead
 * for every shopper who arrives by clicking a link.
 *
 * The listener below is bound to `document`, which is never replaced, so it keeps working
 * across every navigation. It is also idempotent: binding once is enough for the life of
 * the tab.
 *
 * The initial open/closed state does NOT need JavaScript — Liquid already renders
 * #gift-fields with display:none unless cart.attributes['Gift Order'] == 'Yes'.
 */
(function () {
  'use strict';

  // checkbox id -> id of the block it shows and hides
  var TARGETS = {
    'gift-order': 'gift-fields',
    'gift-order-drawer': 'gift-fields-drawer'
  };

  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox || !checkbox.id) return;

    var fieldsId = TARGETS[checkbox.id];
    if (!fieldsId) return;

    var fields = document.getElementById(fieldsId);
    if (!fields) return;

    fields.style.display = checkbox.checked ? 'block' : 'none';
  });
})();
